(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delta-presale-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.getElementById('delta-navbar');
    const navLinks = document.querySelectorAll('.product-nav-link[data-target]');
    
    const sections = Array.from(navLinks).map(link => {
        const targetId = link.getAttribute('data-target').substring(1);
        return document.getElementById(targetId);
    }).filter(el => el !== null); 

    const targetSection = document.getElementById('part-sale-banner');

    if (targetSection) {
        const navbarObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    navbar.classList.remove('visible');
                } else {
                    navbar.classList.add('visible');
                }
            });
        }, {
            threshold: 0.1 
        });
        navbarObserver.observe(targetSection);
    }

    const sectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                navLinks.forEach(link => {
                    link.classList.remove('active');
                });
                const activeLink = document.querySelector(`.product-nav-link[data-target="#${id}"]`);
                if (activeLink) {
                    activeLink.classList.add('active');
                }
            }
        });
    }, {
        rootMargin: '-50% 0px -50% 0px' 
    });

    sections.forEach(section => {
        sectionObserver.observe(section);
    });

    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('data-target').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - navbar.offsetHeight,
                    behavior: 'smooth'
                });
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaud-desktop-features"]) return;
  try {
    
// Keep paired content in native flow; only nearby illustrations follow scroll progress - Plaud Tayler - 2026-10-16 14:16 - Begin
class PlaudDesktopStory extends HTMLElement {
  connectedCallback() {
    this.chapters = [...this.querySelectorAll('[data-pd-chapter]')];
    this.visuals = this.chapters.map(chapter => chapter.querySelector('.pd-feature-row__visual'));
    if (!this.chapters.length) return;
    this.query = matchMedia('(min-width: 769px) and (prefers-reduced-motion: no-preference)');
    this.nearby = new Set();
    this.schedule = () => {
      if (this.active && !document.hidden && this.nearby.size && !this.frame) {
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }
    };
    this.onQuery = () => this.configure();
    this.onVisibility = () => {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (!document.hidden) this.schedule();
    };
    this.query.addEventListener('change', this.onQuery);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.configure();
  }

  configure() {
    this.restore();
    const eligible = this.hasAttribute('data-cinematic') && this.query.matches && !!window.IntersectionObserver;
    if (!eligible) return;
    this.active = true;
    this.classList.add('is-parallax');
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) this.nearby.add(entry.target);
        else this.nearby.delete(entry.target);
      });
      if (this.nearby.size) {
        window.addEventListener('scroll', this.schedule, { passive: true });
        this.schedule();
      } else {
        window.removeEventListener('scroll', this.schedule);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }, { rootMargin: '160px 0px' });
    this.chapters.forEach(chapter => this.observer.observe(chapter));
    this.resize = window.ResizeObserver ? new ResizeObserver(this.schedule) : null;
    this.resize?.observe(this);
    window.addEventListener('resize', this.schedule, { passive: true });
  }

  update() {
    // Read geometry together before writing transforms; text always retains its own scroll position - Plaud Tayler - 2026-10-16 14:16
    const strength = parseFloat(getComputedStyle(this).getPropertyValue('--pd-parallax-strength')) || 0;
    const frames = [...this.nearby].map(chapter => {
      const bounds = chapter.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (bounds.top + bounds.height / 2 - innerHeight / 2) / ((innerHeight + bounds.height) / 2)));
      return { visual: chapter.querySelector('.pd-feature-row__visual'), offset: progress * strength };
    });
    frames.forEach(({ visual, offset }) => visual.style.setProperty('--pd-parallax-y', `${offset.toFixed(3)}%`));
  }

  restore() {
    this.active = false;
    this.observer?.disconnect();
    this.resize?.disconnect();
    this.nearby?.clear();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    window.removeEventListener('scroll', this.schedule);
    window.removeEventListener('resize', this.schedule);
    this.classList.remove('is-parallax');
    this.visuals?.forEach(visual => visual.style.removeProperty('--pd-parallax-y'));
  }

  disconnectedCallback() {
    this.restore();
    this.query?.removeEventListener('change', this.onQuery);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }
}
if (!customElements.get('plaud-desktop-story')) customElements.define('plaud-desktop-story', PlaudDesktopStory);
// Keep paired content in native flow; only nearby illustrations follow scroll progress - Plaud Tayler - 2026-10-16 14:16 - End

  } catch(e) { console.error(e); }
})();
})();
